query LanguagesList(
  $page: Int = 0
  $rowsPerPage: Int = 10
  $filter: LanguagesFilterInput
) {
  languages(page: $page, rowsPerPage: $rowsPerPage, filter: $filter) {
    nodes {
      id
      title
      native
      code
      translation
      createdAt
      updatedAt
      deletedAt
      deleted
    }
    count
  }
}
